import { jsx as _jsx } from "preact/jsx-runtime";
// import { Wrapper } from './styles';
import { Wrapper, Number } from '@genericBookings/components/CustomDatepicker/components/DatepickerDay/styles';
function IndepthDatepickerDay(dayOfMonth, date) {
    if (!date)
        return;
    const month = date.getUTCMonth();
    return (_jsx(Wrapper, { className: `month-${month}`, 
        // lowAvailability={available}
        selected: false, children: _jsx(Number, { children: dayOfMonth }) }));
}
export default IndepthDatepickerDay;
